import { ChartingFlowRouteName } from './model.js';
import { chartingFlowHeadingWithNav } from './privateHelpers.js';

const routesChartingFlowChildren = [
    {
        path: 'print-requisition-forms',
        name: ChartingFlowRouteName.PRINT_REQUISITION_FORMS,
        props: true,
        component: () => import('../../../components/specific/chartingFlow/ChartingFlow/steps/ChartingFlowPrintRequisitionForms.vue.js'),
        meta: {
            authRequired: true,
            heading: chartingFlowHeadingWithNav('Print Requisition Forms'),
            whiteBackground: true,
        },
    },
    {
        path: 'specimen-bags?isDraft=:isDraft?',
        name: ChartingFlowRouteName.SPECIMEN_BAGS,
        props: true,
        component: () => import('../../../components/specific/chartingFlow/ChartingFlow/steps/ChartingFlowSpecimenBags.vue.js'),
        meta: {
            authRequired: true,
            heading: chartingFlowHeadingWithNav('Specimen bags'),
            whiteBackground: true,
        },
    },
];
const routesChartingFlow = [
    {
        path: '/:partnerName?/charting/:orderID?',
        props: true,
        component: () => import('../../../components/specific/chartingFlow/ChartingFlow/ChartingFlow.vue.js'),
        children: routesChartingFlowChildren,
        meta: {
            authRequired: true,
        },
    },
];
/**
 * RootState must be passed as type param.
 *
 * Example: `getRoutesChartingFlow<RootState>()`
 *
 * RootState is type-checked to ensure the routes cannot be added to an app that
 * does not have the necessary vuex modules set up.
 */
const getRoutesChartingFlow = () => routesChartingFlow;

export { getRoutesChartingFlow, routesChartingFlowChildren };
